<!-- =========================================================================================
    File Name: NotAuthorized.vue
    Description: Not Authorized Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div class="h-screen flex w-full bg-img">
		<div
			id="div-with-loading"
			class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center vs-con-loading__container"
		>
			<img src="@/assets/images/pages/not-authorized.png" alt="graphic-not-authorized" class="mx-auto mb-4" />
			<h1 class="sm:mx-0 mx-4 sm:mb-4 mb-4 text-5xl d-theme-heading-color">
				{{ $t("NotAuthorizedPage.Title") }}
			</h1>
			<p class="sm:mx-0 mx-4 sm:mb-8 mb-4 d-theme-heading-color style-data">
				{{ subTitle }}
			</p>
			<vs-button class="font-bold" type="border" @click.stop="login()">{{ $t("Login.Login") }}</vs-button>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			fromRoute: null,
		};
	},
	props: {
		subTitle: {
			type: String,
			required: "",
		},
		showData: Function,
		login: Function,
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.fromRoute = from;
		});
	},
};
</script>
<style lang="scss" scoped>
.style-data {
	font-style: normal;
	font-size: 15px;
	line-height: 18px;
}
</style>
